export const OfferStatusModeration = {
  IN_PROCESS: 11550,
  FAILED: 16550,
  PASSED: 17550,
  DRAFT: 19550,
} as const

export const OfferStatusActivity = {
  ACTIVE: 21550,
  ARCHIVE: 27550,
  SOLD: 29550,
} as const
